import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BasketService } from 'src/app/services/basket.service';
import { HotelService } from 'src/app/services/hotel.service';
import { OpenTableService } from 'src/app/services/open-table.service';
import { Store } from 'src/app/store';

@Component({
    selector: 'app-open-table',
    templateUrl: './open-table.component.html',
    styleUrls: ['./open-table.component.css']
})
export class OpenTableComponent implements OnInit {
    itemIdx = -1;
    item;
    continueText = 'Continue';
    dataToView = undefined;

    availabilitySearch$ = this.store.select<any>('availabilitySearch');
    passportValidated$ = this.store.select<boolean>('passportValidated');
    basket$ = this.store.select<any>('basket');
    hotel$ = this.store.select<any>('hotel');
    error = '';

    nextUrl = '';
    prevUrl = '';

    c = this.store.selectForLocal('availabilitySearch');
    hotel;
    comments = '';
    showComments = false;

    basketCounts = {};

    slot;
    slots = [];
    slotSelected = '';
    partySize: number = 2;

    tableBooking = {
        hotelId: '',
        partySize: 2,
        slotSelected: '',
        dateTime: undefined,
        booker: {
            firstname: '',
            surname: '',
            email: '',
            telephone: '',
        },
        dietary: '',
        notes: '',
        lockResult: undefined,
        slotLockAttempted: false,
        area: undefined,
        environment: undefined,
        reservationAttribute: '',
    }

    areas = [];
    attributes = [];
    attributesOnSlot = [];
    dupeBooking = false;
    diningAreas = [];

    constructor(
        private store: Store,
        private fb: FormBuilder,
        private hotelService: HotelService,
        public route: ActivatedRoute,
        private router: Router,
        private basketService: BasketService,
        private openTableService: OpenTableService,
    ) { }

    ngOnInit() {
        this.itemIdx = 0;

        const basket = this.store.selectForLocal('basket');
        const basketBooking = this.store.selectForLocal('basketBooking');
        console.log(basketBooking)
        if (!basket) {
            this.router.navigate(['/bookings/create/payment'])
        }

        this.item = basket.items[this.itemIdx];

        this.continueText = 'Continue';

        this.tableBooking.hotelId = basketBooking.hotelId;

        this.store.set('showHeaderBanner', false);
        this.store.set('currentView', 'room-availability');
        console.log(this.item)


        this.tableBooking.booker.firstname = basket.user.firstname;
        this.tableBooking.booker.surname = basket.user.surname;
        this.tableBooking.booker.email = basket.user.username;
        if (!basket.user.telephone) {
            this.tableBooking.booker.telephone = basket.user.mobile;
        } else {
            this.tableBooking.booker.telephone = basket.user.telephone;
        }

        if (this.tableBooking.booker.telephone) {
            this.tableBooking.booker.telephone = this.tableBooking.booker.telephone.replace('+44', '0')
        }

        this.tableBooking.partySize = +this.item.availabilitySearch.adults;

        this.tableBooking.dateTime = this.toLocalISOString(new Date(this.item.availabilitySearch.checkIn));


        this.getHotel(basketBooking.hotelId);


    }

    refreshAvailability() {
        this.tableBooking.slotSelected = '';
        this.tableBooking.area = undefined;
        this.tableBooking.environment = undefined;
        this.tableBooking.slotSelected = '';

        this.getMeta();
    }

    getMeta() {
        this.openTableService.meta(this.hotel.id).subscribe(data => {
            console.log(data.data.data)
            this.areas = data.data.data.dining_areas
            this.attributes = data.data.data.attributes;
            console.log(this.areas)
            console.log(this.attributes)

            this.getAvailability();
        })
    }

    getAvailability() {
        this.openTableService.slots(this.hotel.id, this.tableBooking.dateTime, this.tableBooking.partySize).subscribe(data => {
            console.log(data.data.times_available)


            data.data.times_available.forEach(e => {
                // Extract time part from '2025-10-27T13:00' → '13:00'
                const otTime = e.time.split('T')[1];
                const otTimeNumber = otTime.replace(':', ''); // '1300'

                // Get current time in local timezone as 'HH:mm'
                const now = new Date();
                const hours = now.getHours().toString().padStart(2, '0');
                const minutes = now.getMinutes().toString().padStart(2, '0');
                const timeNow = hours + minutes; // e.g., '1337'

                // Compare time strings numerically
                e.available = +otTimeNumber > +timeNow;
            });
            this.slots = data.data.times_available;

            console.log(this.slots)
        })

    }


    toLocalISOString(date: Date): string {
        const pad = (n: number) => n.toString().padStart(2, '0');

        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1); // getMonth() is zero-based
        const day = pad(date.getDate());
        //   const hours = pad(date.getHours());
        const hours = 17;
        const minutes = pad(date.getMinutes());

        return `${year}-${month}-${day}T${hours}:${minutes}`;
    }

    isValidPhoneNumber(value: string): boolean {
        const phonePattern = /^0\d{10}$/;

        return phonePattern.test(value);
    }

    selectSlot(slot) {


        this.error = '';

        if (!this.tableBooking.booker.firstname || !this.tableBooking.booker.surname || !this.tableBooking.booker.email || !this.tableBooking.booker.telephone) {
            this.error = 'Please complete all guest details'
            return false;
        }

        console.log(this.isValidPhoneNumber(this.tableBooking.booker.telephone))
        if (!this.isValidPhoneNumber(this.tableBooking.booker.telephone)) {
            this.error = 'Please enter a validate telephone number'
            return false;

        }


        this.dupeBooking = false;

        this.tableBooking.reservationAttribute = '';
        this.tableBooking.environment = undefined;
        this.tableBooking.area = undefined;

        console.log(slot)
        this.slot = slot;

        // get the dining areas available based on slot.availability_types Vs meta.dining_areas
        const areas = [];
        slot.availability_types.forEach(at => {
            at.dining_area.forEach(da => {
                areas.push(da)
            });
        });
        console.log(areas)

        // now match the areas to the meta.dining_areas
        console.log(this.areas)
        this.diningAreas = [];

        areas.forEach(la => {
            this.areas.forEach(a => {
                if (la.id === a.id) {
                    this.diningAreas.push({ id: a.id, name: a.name, environment: a.environment, attributes: la.attributes })
                }
            })
        })
        console.log(this.diningAreas)
        this.attributesOnSlot = [];
        slot.availability_types.forEach(element => {
            element.dining_area.forEach(e => {
                e.attributes.forEach(a => {
                    this.attributesOnSlot.push(a)
                });
            });
        });

        if (slot.time === this.tableBooking.slotSelected) {
            this.tableBooking.slotSelected = '';
            this.tableBooking.area = undefined;
            this.tableBooking.environment = undefined;
            return;
        }
        this.tableBooking.slotSelected = slot.time;

        this.checkDupe();


        // if (this.attributesOnSlot.length < 2) {

        //     this.selectAttribute(this.attributesOnSlot[0])
        // }

    }

    checkDupe() {
        this.openTableService.checkDupe(this.tableBooking).subscribe(data => {

            this.dupeBooking = data.data;
        })
    }
    isAvailable(a) {
        if (this.attributesOnSlot.indexOf(a) > -1) {
            return true;
        } else {
            return false;
        }
    }
    selectArea(area) {
        this.tableBooking.area = area.id;
        if (area.environment) {
            this.tableBooking.environment = area.environment;
        } else {
            this.tableBooking.environment = 'Indoor';
        }
    }
    selectAttribute(diningArea, attribute) {
        this.tableBooking.reservationAttribute = attribute;

        // if (diningArea.environment) {
        //     this.tableBooking.environment = diningArea.environment;
        // } else {
        //     this.tableBooking.environment = 'Indoor';
        // }
        this.slot.availability_types.forEach(at => {
            at.dining_area.forEach(da => {
                console.log(da.id, diningArea.id)
                if (da.id === diningArea.id) {
                    console.log(da)
                    this.tableBooking.environment = da.environment;
                }
            });
        });

        this.tableBooking.area = diningArea.id;

        // this.slot.availability_types.forEach(element => {
        //     element.dining_area.forEach(e => {
        //         e.attributes.forEach(a => {
        //             if (a === attribute) {
        //                 this.tableBooking.environment = e.environment;
        //                 this.tableBooking.reservationAttribute = a;
        //                 this.tableBooking.area = e.id;
        //             }
        //         });
        //     });
        // });
        console.log(this.tableBooking.area, this.tableBooking.environment, this.tableBooking.reservationAttribute);
    }

    getHotel(hotelId) {
        this.hotelService.getHotelBySlug(hotelId).subscribe(data => {
            this.hotel = data;
            console.log(data)
            this.getMeta()
            const basket = this.store.selectForLocal('basket');
        })
    }

    basketPosition(product) {
        if (this.itemIdx >= 0) {
            return this.basketService.basketAddOnPosition(product, this.itemIdx);
        }

        return -1;
    }

    slotLock() {
        this.openTableService.slotLock(this.tableBooking).subscribe(data => {
            if (!data.data.reservation_token) {
                data.data.success = false;
            } else {
                data.data.success = true;
            }
            console.log(data.data);
            if (data.data.success) {
                this.tableBooking.slotLockAttempted = true;
                this.tableBooking.lockResult = data.data;
                this.basketService.addOpenTable(this.tableBooking, this.itemIdx)
            } else {
                this.tableBooking.slotLockAttempted = false;
                this.error = 'Sorry - unable to reserve your slot. Please contact customer services to book.'
            }

        })
    }


    back(e) {
        this.router.navigate(['/checkout'])
    }
    continue(e) {
        if (!this.error) {
            const user = this.store.selectForLocal('user');
        }


        const basket = this.store.selectForLocal('basket');
        this.item = basket.items[this.itemIdx];

        this.router.navigate(['/bookings/create/payment'])

        // this.router.navigate([this.nextUrl]);
    }

    get expiresAtLocal(): string {
        return this.tableBooking.lockResult.expires_at + 'Z';
    }

    ignore() {
        this.router.navigate(['/bookings/create/payment'])
    }
}
